import React from 'react';
import ReactDOM from 'react-dom';
import EmbedApp from './EmbedApp';
import { bootstrap } from './bootstrap';

bootstrap();
ReactDOM.render(<EmbedApp />, document.getElementById('embed-root'));
